import React from "react";
import ReactDOM from "react-dom/client";
//import StarRating from "./StarRating";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
